import { schemes, zSchema } from "@zeal/common";

export const postPaymentSummaryRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  pay_start_date: zSchema.string(),
  pay_end_date: zSchema.string(),
  media_type: zSchema.string(),
  include_intl_contractors: zSchema.boolean(),
});

export type TPostPaymentSummaryRequestSchema = zSchema.infer<
  typeof postPaymentSummaryRequestSchema
>;
